/**
 * #23 — passerelle minimale pour le réglage « son ».
 *
 * POURQUOI CE FICHIER EXISTE.
 * `playRingDing` (TwilioDeviceContext) sonne un 880 Hz toutes les 1,5 s pendant
 * toute la phase de sonnerie entrante, et n'était gardé par AUCUN réglage —
 * contrairement à `playDialBeep` et `playConnectionBeep`, qui respectent tous
 * deux `soundEnabled`. Mesuré : 2 oscillateurs émis alors que le réglage est
 * censé piloter les sons de l'application.
 *
 * TwilioDeviceContext n'importe pas le contexte de réglages, et le lui faire
 * importer créerait un cycle (les réglages dépendent de l'auth, qui dépend du
 * device). Ce module est le seau qu'on se passe entre les deux : le contexte
 * de réglages y dépose la valeur, le contexte Twilio la lit. Pas de React, pas
 * de cycle, une seule source.
 */
let sonActif = true;

/** Appelé par DialerSettingsContext à chaque changement de `soundEnabled`. */
export function definirSonActif(valeur: boolean): void {
  sonActif = valeur !== false;
}

/** Lu par les émetteurs de son qui n'ont pas accès au contexte React. */
export function sonEstActif(): boolean {
  return sonActif;
}
